<template>
  <div class="m-consumption dutebottom">
    <div class="u-toptilte">
      <p><i style="color: #FFCC00">▎</i>海星点充值记录</p>
    </div>

    <div v-if="!zanwusj" class="section">
      <div class="section_oldson">
        <ul class="so_ul">
          <li>
            <p>充值点数</p>
            <p>充值时间</p>
            <p>充值类型</p>
            <p>备注</p>
          </li>
          <li v-for="(i, index) in chongzhiData" :key="index">
            <p>{{ i.num }}</p>
            <p>{{ i.desc }}</p>
            <p>{{ i.createdat.substring(0, i.createdat.indexOf("T")) }}</p>
            <p>{{ i.remark }}</p>
          </li>
        </ul>
      </div>

      <div class="u-btnpage">
        <span>共{{ gongye }}页</span>
        <span>当前{{ dangqianye }}页</span>
        <a @click="shang">上一页</a>

        <a @click="xia">下一页</a>
      </div>
    </div>
    <div v-if="zanwusj" class="no-Order">
      <img draggable="false" src="../../static/percttent/nodd.png" />
      <p>暂无充值记录！</p>
    </div>
    <div class="Timecardrechargerecord_die">
      <div class="Timecardrechargerecord">
        <div class="u-toptilte">
          <p><i style="color: #FFCC00">▎</i>计时卡充值记录</p>
        </div>
        <ul class="TCDCGC">
          <li class="TCDCGC_title">
            <div>名称</div>
            <div>价格</div>
            <div>使用状态</div>
            <div>开始时间</div>
            <div>结束时间</div>
            <div>购买时间</div>
          </li>
          <li
            class="TCDCGC_conten"
            v-for="(item, i) in this.renderAfterPagination"
            :key="i + 1"
          >
            <div>{{ item.title }}</div>
            <div>{{ item.price }}</div>
            <div :style="{ color: item.status == 1 ? '#F4C91D' : '#ffffff' }">
              {{
                item.status == 0
                  ? "未使用"
                  : item.status == 1
                  ? "正在使用"
                  : "已使用"
              }}
            </div>
            <div>
              {{ item.start_at.substring(0, item.start_at.indexOf("T")) }}
            </div>
            <div>{{ item.end_at.substring(0, item.end_at.indexOf("T")) }}</div>
            <div>
              {{ item.created_at.substring(0, item.created_at.indexOf("T")) }}
            </div>
          </li>
        </ul>
        <div class="u-btnpage">
          <span>共{{ this.page == 0 ? 1 : this.page }}页</span>
          <span
            >当前{{ this.currentPage == 0 ? 1 : this.currentPage + 1 }}页</span
          >
          <a @click="downye">上一页</a>

          <a @click="upye">下一页</a>
        </div>
      </div>
    </div>
    <!-- <div v-if="zanwusj" class="no-Order">
      <img src="../../static/percttent/nodd.png" />
      <p>暂无充值记录！</p>
    </div>
    <div class="czjilu">
      <p class="fl dian" style="width:220px">充值点数</p>
      <p class="fl leixing" style="width:268px">充值类型</p>
      <p class="fl time" style="width:350px">充值时间</p>
    </div>
    <span
      style="display:block;font-size:30px;line-height:200px;text-align:center"

    >暂无数据</span>
    <ul>
      <li v-for="(i,index) in chongzhiData" :key="index">
        <p class="fl dian" style="width:220px">{{i.num}}</p>
        <p class="fl leixing" style="width:268px">{{i.desc}}</p>
        <p
          class="fl time"
          style="width:350px"
        >{{i.createdat.split("T").join(" ").split("+").shift()}}</p>
      </li>
    </ul>-->
  </div>
</template>
<script>
export default {
  metaInfo: {
    title:'海星云充值记录,云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content:'海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content:'海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      zanwusj: true,
      token: '',
      chongzhiData: '',
      dangqianye: '',
      gongye: '',
      // yang
      timecard_list: [], // 计时卡部分数据
      page: 0, // 页码数
      currentPage: 0, // 当前页
      page_timecard_list: [], // 分页后数据
      renderAfterPagination: [] // 真正渲染的数据

    }
  },
  methods: {
    shang () {
      this.dangqianye = this.dangqianye - 1
      this.http.sxye(this.dangqianye, 0).then(res => {
        this.chongzhiData = res.data.data.charge_list
      })
      if (this.dangqianye < 1) {
        this.dangqianye = 1
        return false
      }
    },
    xia () {
      this.dangqianye = this.dangqianye + 1
      this.http.sxye(this.dangqianye, 0).then(res => {
        this.chongzhiData = res.data.data.charge_list
      })
      if (this.dangqianye > this.gongye) {
        this.dangqianye = this.gongye
        return false
      }
    },
    Rechargehistory (dangqianye) {
      this.http.CZRechargehistory(dangqianye)
    },
    // 计时卡分页 下一页
    upye () {
      if (this.currentPage < this.page - 1) {
        this.currentPage += 1
      } else if (this.currentPage > this.page) {
        this.currentPage = this.page
      }

      this.renderAfterPagination = this.page_timecard_list[this.currentPage]
      // console.log(this.page, this.page_timecard_list)
    },
    // 上一页
    downye () {
      this.currentPage -= 1
      if (this.currentPage < 0) {
        this.currentPage = 0
      }
      this.renderAfterPagination = this.page_timecard_list[this.currentPage]
    }

  },
  mounted () {
    this.token = this.$cookieStore.getCookie('user_sess')
    if (!this.token) {
      this.$message({
        message: '抱歉！您还没登录',
        type: 'warning'
      })
      return false
    } else {
      this.http.chongzhijl(0).then(res => {
        this.chongzhiData = res.data.data.charge_list
        if (this.chongzhiData.length == 0) {
          this.zanwusj = true
        } else {
          this.zanwusj = false
        }
        this.dangqianye = res.data.data.cur_page
        this.gongye = res.data.data.total_page
        this.Rechargehistory(this.dangqianye)
      })
      this.http.Timecardrechargerecord().then(res => {
        this.timecard_list = res.data.data.timecard_list
        this.page = Math.ceil(this.timecard_list.length / 7)
        for (let i = 0; i < this.timecard_list.length; i += 7) {
          this.page_timecard_list.push(this.timecard_list.slice(i, i + 7))
        }
        this.renderAfterPagination = this.page_timecard_list[0]
      })
    }
  }
}
</script>
<style scoped>
.Timecardrechargerecord {
  position: absolute;
  width: 1010px;
  min-height: 549px;
  top: 105%;
  left: 0;
  padding: 30px;

  /* border: 1px solid #fff; */
  /* border-radius: 10px; */
  background: rgba(156, 165, 236, 0.1);
}
.dutebottom {
  margin-bottom: 70% !important;
  /* padding: 30px 30px; */
}
@media screen and (min-width: 900px) and (max-width: 1200px) {
  .Timecardrechargerecord {
    width: 834px;
  }
  .dutebottom {
    width: 834px !important;
  }
}
@media screen and (min-width: 700px) and (max-width: 899px) {
  .Timecardrechargerecord {
    width: 538px;
  }
  .dutebottom {
    margin-bottom: 200% !important;
  }
}
@media screen and (min-width: 580px) and (max-width: 699px) {
  .Timecardrechargerecord {
    width: 404px;
  }
  .TCDCGC li div {
    font-size: 12px !important;
  }
  .TCDCGC li {
    margin: 0 auto;
    width: 100%;
  }
  .dutebottom {
    margin-bottom: 100% !important;
  }
}
@media screen and (min-width: 400px) and (max-width: 579px) {
  .Timecardrechargerecord {
    top: 110%;
    width: 100%;
  }
  .TCDCGC li div {
    font-size: 12px !important;
  }
  .TCDCGC li {
    margin: 0 auto;
    width: 100%;
  }
  .dutebottom {
    /* margin-bottom: 1050px !important; */
    margin-bottom: 222% !important;
    margin-top: 30px;
  }
}
@media screen and (min-width: 375px) and (max-width: 399px) {
  .Timecardrechargerecord {
    width: 100%;
    top: 110%;
  }
  .dutebottom {
    /* margin-bottom: 1050px !important; */
    margin-bottom: 260% !important;
    margin-top: 30px;
  }
  .TCDCGC li {
    margin: 0 auto;
    width: 100%;
  }
}
@media screen and (min-width: 320px) and (max-width: 374px) {
  .Timecardrechargerecord {
    width: 100%;
    top: 110%;
    overflow-x: auto;
  }
  .dutebottom {
    /* margin-bottom: 1050px !important; */
    margin-bottom: 280% !important;
    margin-top: 30px;
  }
  .TCDCGC li {
    width: 550px !important;
  }
}
@media screen and (max-width: 319px) {
  .Timecardrechargerecord {
    width: 100%;
    top: 130%;
    overflow-x: auto;
  }
  .dutebottom {
    /* margin-bottom: 1050px !important; */
    margin-bottom: 300% !important;
    margin-top: 30px;
  }
  .TCDCGC li {
    width: 550px !important;
  }
}

.TCDCGC {
  width: 100%;
  min-height: 385px !important;
}
.TCDCGC li {
  width: 85%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 14px;
  padding: 9px 0 9px 0;
}
.TCDCGC_title {
  font-weight: 900;
  overflow: hidden;
  padding: 15px 0 15px 0 !important;
}
.TCDCGC_title div {
  font-size: 16px !important;
}
.TCDCGC li div {
  text-align: center;
  font-size: 14px;
  width: 150px;
}
.section div:nth-child(1) {
  min-height: 380px;
}
.section {
  padding: 0 40px;
}
.has-gutter tr {
  display: flex !important;
  justify-content: space-between !important;
}
.has-gutter {
  background-color: coral !important;
}
.Personal-Center .el-table,
.Personal-Center .el-table__expanded-cell,
.Personal-Center .el-table th,
.Personal-Center .el-table tr {
  width: 100%;
  margin: 0 auto;
}
@media screen and (max-width: 500px) {
  .Personal-Center .el-table,
  .Personal-Center .el-table__expanded-cell,
  .Personal-Center .el-table th,
  .Personal-Center .el-table tr {
    width: 100% !important;
    margin: 0 auto;
  }
  .TCDCGC li {
    width: 100% !important;
  }
  .section {
    padding: 0 !important;
  }
}
.TCDCGC_conten:hover {
  background: #12102f;
}
.TCDCGC_conten {
  transition-duration: 0.2s;
}
.section_oldson {
  width: 93%;
  margin: 0 auto;
}
/*  */

.so_ul {
  height: 100%;
}
.so_ul li:nth-child(1) {
  padding: 15px 0 15px 0;
  font-weight: 900;
}
.so_ul li:nth-child(1):hover {
  background: transparent;
}
.so_ul li {
  font-size: 14px;
  padding: 8px 0 8px 0;
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.so_ul li:hover {
  background: #12102f;
}
.so_ul li p {
  width: 130px;
  text-align: center;
}
/* #Recharge {
  width: 838px;
  height: 792px;
  border: 15px solid #fff;
  background: rgba(242, 242, 242, 1);
  border-radius: 13px;
  position: relative;
}
#Recharge > p {
  height: 80px;
  font-size: 24px;
  font-weight: bold;
  color: rgba(41, 92, 164, 1);
  line-height: 80px;
  padding: 0 20px;
  border-bottom: 2px solid #fff;
}
#Recharge > p img {
  margin-right: 20px;
  vertical-align: middle;
}
.czjilu {
  overflow: hidden;
  border-bottom: 2px solid #fff;
}
.czjilu p {
  font-size: 24px;
  color: rgba(41, 92, 164, 1);
  height: 75px;
  line-height: 75px;
  text-align: center;
}
#Recharge ul li {
  overflow: hidden;
  border-bottom: 2px solid #fff;
  height: 75px;
}
#Recharge ul li p {
  text-align: center;
  font-size: 20px;
  color: rgba(43, 43, 43, 1);
  line-height: 75px;
}
#Recharge .btn {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-around;
  padding: 30px 6.25rem 30px 1.875rem;
}
#Recharge .btn span {
  display: inline-block;
  width: 3.125rem;
  border: 1px solid #dfdfdf;
  padding: 6px 1.25rem;
  line-height: 14px;
  border-radius: 13px;
  text-align: center;
  background: #fff;
  color: #3c3c3c;
  transition: background-color 0.5s;
  margin-left: 80px;
} */
/* #Recharge .btn span:hover {
  background: #dfdfdf;
} */
</style>



// WEBPACK FOOTER //
// src/components/Recharge.vue